var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useLocation } from "react-router-dom";
import "../styles/Footer.css";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
function Footer() {
    var location = useLocation();
    var isFaqPage = location.pathname === "/faq";
    var message = isFaqPage
        ? "Não encontrei minha resposta no FAQ, preciso de ajuda."
        : "Olá! Preciso falar com meu CS.";
    var whatsappUrl = "https://api.whatsapp.com/send?phone=552140036095&text=".concat(encodeURIComponent(message));
    return (_jsx("footer", __assign({ className: "border-bottom bottom" }, { children: _jsx("a", __assign({ href: whatsappUrl, className: "wp-btn", target: "_blank", rel: "noreferrer" }, { children: _jsx(WhatsAppIcon, { className: "admin-footer-whatsapp provider-home-whatsapp" }) })) })));
}
export default Footer;
